export const WIDTH = 80;
export const HEIGHT = 50;
export const FONT_SIZE = 15;

export const DIJKSTRA_MAX = 10000000;
